import React from 'react';
import Childrens2025 from '../views/Childrens2025';

const ClassAssemblyPage = () => {
    return <Childrens2025/>;
  };
  export default ClassAssemblyPage;